import { ChangeDetectionStrategy, Component } from '@angular/core';

import {
  REFERRAL_FAQ_ITEMS,
  REFERRAL_TERMS_SECTIONS,
  REFERRAL_TERMS_TITLE,
  REFERRAL_TERMS_UPDATED,
} from '@app/pages/referrals-page/referrals-faq.content';

@Component({
  selector: 'referral-faq-section',
  templateUrl: './referral-faq-section.component.html',
  styleUrls: ['./referral-faq-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReferralFaqSectionComponent {
  faqItems = REFERRAL_FAQ_ITEMS;
  termsTitle = REFERRAL_TERMS_TITLE;
  termsUpdated = REFERRAL_TERMS_UPDATED;
  termsSections = REFERRAL_TERMS_SECTIONS;
  previewCount = 10;
  showAll = false;

  expandedIndex: number | null = null;

  get visibleFaqItems() {
    return this.showAll ? this.faqItems : this.faqItems.slice(0, this.previewCount);
  }

  get canShowMore() {
    return !this.showAll && this.faqItems.length > this.previewCount;
  }

  toggle(index: number) {
    this.expandedIndex = this.expandedIndex === index ? null : index;
  }

  isExpanded(index: number) {
    return this.expandedIndex === index;
  }

  showMore() {
    this.showAll = true;
  }
}
